import React, { useState, useEffect, Fragment, useContext } from "react";
import { useNavigate, useParams, Link, json, useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import toast, { Toaster } from "react-hot-toast";
import {
	logBatchesHistory,
	getBatchesUUID1,
	getBatchesList1,
	loggedInUserUrls,
	getWarehouseKeyValueList,
} from "../../../services/index";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { getFormattedNumber, searchForMatch } from "../../utils/textUtils";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from 'react-select';
import { getAllQCUsers, getBatchModalDetails } from "../../../services/Production/BatchesServices";
import { getQualityParaMeterKeyValuePair } from "../../../services/Master/QualityParameterServices";
import { Key } from "@mui/icons-material";
import { AuthUrlContext } from "../../../context/createContext";

const physicalQualityOptions = [
	{ label: "Accept", value: "Accept" },
	{ label: "Reject", value: "Reject" },
	{ label: "Hold", value: "Hold" },
	{ label: "Pending", value: "Pending" },
]



const ViewBatch = (props) => {
	let { id } = useParams();
	const navigate = useNavigate();
	const [logData, setLogData] = useState({});
	const [rId, setRId] = useState([]);
	const [batchRec, setBatchRec] = useState([]);
	const [rows, setRows] = useState([]);
	const [rows2, setRows2] = useState([]);
	const [batchDetails, setBatchDetails] = useState([]);
	const [index, setIndex] = useState(0);
	const [filterText, setFilterText] = useState("");
	const [redirState, setRedirState] = useState(false);
	const [dataId, setDataId] = useState();
	const [batchListDetails, setBatchListDetails] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [parameterizeQualityCheck, setParameterizeQualityCheck] = useState("");
	const [physicalQualityCheckEnum, setPhysicalQualityCheckEnum] = useState("");
	const [qualityCheckComment, setQualityCheckComment] = useState("");
	const [qualityParameterOptions, setQualityParameterOptions] = useState(null);
	const [checkedParameters, setCheckedParameters] = useState({});
	const [preSelected, setPreSelected] = useState([]);
	const [userRights, setUserRights] = useState("");
	const [QuanlityCheckDoneBy, setQuanlityCheckDoneBy] = useState();
	const location = useLocation()
	const [wareOptions, setWareOptions] = useState([]);
	const [selectedWarehouse, setSelectedWarehouse] = useState("");
	const [QcDoneBy, setQcDoneBy] = useState([])

	// Batch details and the QC user list load in parallel. Pick the saved "QC done by" only once both
	// are here, whichever arrives first. A saved name that is no longer in the list is still shown.
	useEffect(() => {
		const savedName = batchDetails?.qualityCheckDoneBy;
		if (!savedName || QcDoneBy.length === 0) return;
		const match = QcDoneBy.find((e) => e.value == savedName);
		if (match) {
			setQuanlityCheckDoneBy(match);
		} else {
			const legacy = { value: savedName, label: savedName };
			setQcDoneBy((prev) => [legacy, ...prev]);
			setQuanlityCheckDoneBy(legacy);
		}
	}, [QcDoneBy, batchDetails]);


	useEffect(() => {
		getWarehouseKeyValueList().then((res) => {
			if (res.errorCode === 0) {
				const options = res.responsePacket.map((d) => ({
					value: d.key,
					label: d.value,
				}));
				if (location.state?.ware) {
					setSelectedWarehouse(location.state.ware)
				}
				else {
					setSelectedWarehouse(options[0]);
				}
				setWareOptions(options);
			}
		});
	}, []);


	const handleSelectWarehouse = (e) => {
		setSelectedWarehouse(e);
		setIndex(0);
		setFilterText("");
	};




	const editItems = () => {
		setRedirState(true);
		setDataId(batchDetails.recordId);
	};

	useEffect(() => {
		loggedInUserUrls().then((res) => {
			if (res.errorCode === 0) {
				setUserRights(res.responsePacket);
			} else {
				toast.error(res.message);
			}
		});
	}, [])

	useEffect(() => {
		logBatchesHistory(id).then((res) => {
			if (res.errorCode == 0) {
				const d = res.responsePacket;
				setLogData(d);
			} else {
				toast(res.message);
			}
		});
	}, [id]);

	useEffect(() => {
		getQualityParaMeterKeyValuePair().then((res) => {
			if (res.errorCode === 0) {
				const options = res.responsePacket?.map((d) => ({
					key: d.key,
					value: d.key,
					label: d.value,
				})) || [];
				// const filteredOptions = options.filter(option => {
				// 	return !preSelected?.includes(option.label);
				// });
				setQualityParameterOptions(options);
			} else {
				toast(res);
			}

		});
	}, [batchDetails, showModal, parameterizeQualityCheck, id]);

	const getBatchDetails = (id) => {
		getBatchesUUID1(id).then((res) => {
			if (res.errorCode == 0) {
				const response = res.responsePacket;
				const _physicalQualityCheckEnum = physicalQualityOptions.find((item) => item.value === response.physicalQualityCheckEnum);
				setBatchDetails(response);
				// setParameterizeQualityCheck(JSON.parse(response?.parameterizeQualityCheck));
				setQualityCheckComment(response.qualityCheckComment);
				setPhysicalQualityCheckEnum(_physicalQualityCheckEnum);
				if (response?.parameterizeQualityCheck) {
					try {
						const parsedQualityCheck = JSON.parse(response.parameterizeQualityCheck);
						let SelectedData = parsedQualityCheck.map((e) => {
							return { label: e.label, value: e.key, key: e.key, checked: e.checked }
						}
						)
						setParameterizeQualityCheck(SelectedData);
					} catch (error) {
						console.error("Error parsing parameterizeQualityCheck:", error);
						// Optionally set to an empty array or handle the error gracefully
						setParameterizeQualityCheck([]);
					}
				} else {
					setParameterizeQualityCheck([]); // Set to an empty array if undefined
				}

			} else {
				toast.error(res.message);
			}
		});
	};
	useEffect(() => {
		if (batchDetails.parameterizeQualityCheck) {
			const check = {};
			const selected = []
			try {
				const parsedChecks = JSON.parse(batchDetails?.parameterizeQualityCheck);
				parsedChecks.forEach(element => {
					check[element.value] = element.checked;
					selected.push(element.value)
				});
				setPreSelected(selected)
				setCheckedParameters(check);
			} catch (error) {
				console.error('Error parsing parameterizeQualityCheck:', error);
			}
		}
		else {
			setPreSelected([])
		}

	}, [batchDetails, id]);

	const handleCheckboxChange = (key) => {
		setCheckedParameters((prev) => ({
			...prev,
			[key]: !prev[key],
		}));
	};


	const getAllBatchRecords = () => {
		let batch_data = {
			page: index,
			size: 15,
			search: filterText,
			warehouseId: location?.state?.warehouseId || selectedWarehouse?.value
		};
		getBatchesList1(batch_data).then((res) => {
			if (res.errorCode === 0) {
				if (index === 0) {
					setBatchRec(res.responsePacket.data);
					const d = res.responsePacket.data;
					setRows(d);
					setRows2(d);
					const data = res.responsePacket.data;
					const options = data.map((d) => ({
						value: d.recordId,
					}));
				} else {
					const setBatchClone = [...rows, ...res.responsePacket.data];
					setRows(setBatchClone);
					setRows2(setBatchClone);
				}
				setIndex(index + 1);
				setBatchListDetails({
					recordsFiltered: res.responsePacket.recordsFiltered,
					recordsTotal: res.responsePacket.recordsTotal,
					total: res.responsePacket.total,
				});
			} else {
				toast(res.message);
			}
		});
	};



	const getAllQCUser = () => {
		getAllQCUsers().then((res) => {
			if (res.errorCode === 0) {
				let options = res?.responsePacket.map((e) => {
					return { value: e.fullName, label: e?.fullName }
				})
				setQcDoneBy(options || [])
				// QuanlityCheckDoneBy(options[0])
				// setQcUsers(res.responsePacket.data);
			}
		}
		)
	}


	useEffect(() => {
		// if (QcDoneBy.length > 0 && id) {
		if (id) {
			getBatchDetails(id);
		}
		getAllBatchRecords();
	}, [id]);
	
	useEffect(() => {
		getAllQCUser()
	}, [])


	useEffect(() => {
		getAllBatchRecords();
	}, [filterText, selectedWarehouse]);

	const handleEditBatch = (id) => {
		navigate("/batches/" + id + "/edit");
	};

	let time;
	const handleSearch = (e) => {
		const { value } = e.target;
		clearTimeout(time);
		time = setTimeout(() => {
			setIndex(0);
			setFilterText(value);
		}, 500);
	};

	const batchModalDetailsSubmit = (id) => {
		// QC By is mandatory; without it the payload below would read .value of undefined and crash.
		if (!QuanlityCheckDoneBy?.value) {
			toast.error(QcDoneBy.length === 0 ? "No QC users found. Add users with the QC role first." : "Select QC By");
			return;
		}
		// const _parameterizeQualityCheck = parameterizeQualityCheck.map(param => ({
		// 	key: param.value,
		// 	checked: checkedParameters[param.value] || false,
		// }))
		const _parameterizeQualityCheck = parameterizeQualityCheck.map(param => {
			return {
				key: param.value,
				value: param.label,
				label: param.label,
				checked: checkedParameters[param.value] || false,
			}
		})
		const data = {
			parameterizeQualityCheck: JSON.stringify(_parameterizeQualityCheck),
			physicalQualityCheckEnum: physicalQualityCheckEnum?.value || null,
			qualityCheckComment: qualityCheckComment,
			qualityCheckDoneBy: QuanlityCheckDoneBy.value
		};

		getBatchModalDetails(id, data)
			.then((res) => {
				if (res.errorCode === 0) {
					toast.success(res.message);
					setShowModal(false);
				} else {
					toast.error(res.message);
				}
			})
			.catch((error) => {
				toast.error("Submission failed. Please try again.");
			})
			.finally(() => getBatchDetails(id))
	};

	const assignSyncButton = () => {
		let buttonFlag = false;
		if (userRights.adminRoleEnum === "ROLE_SUPER_ADMIN") {
			buttonFlag = true;
		} else {
			userRights?.urlList?.map((url) => {
				if (url.url === '/qualityCheck/{uuid}') {
					buttonFlag = true;
				}
			})
		}
		return buttonFlag;
	}
	const formatDateString = (dateStr) => {
		let date = new Date(dateStr);
		let day = String(date.getDate()).padStart(2, '0');
		let month = String(date.getMonth() + 1).padStart(2, '0');
		let year = date.getFullYear().toString().slice(-2);
		let hours = String(date.getHours()).padStart(2, '0');
		let minutes = String(date.getMinutes()).padStart(2, '0');
		let seconds = String(date.getSeconds()).padStart(2, '0');
		return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
	}

	return (
		<>
			<div
				className="list-column column d-print-none"
				style={{ width: "300px" }}
			>
				<div className="fill list-header topgrad d-print-none">
					<div className="listFilterAndSearch list-filter pt-3 d-flex align-items-center">
						<Link to="/batches/new" className="newListBtn">
							<AddIcon />
							New
						</Link>
						<div className="listFilter">
							<Select value={selectedWarehouse} options={wareOptions} onChange={handleSelectWarehouse} />
						</div>
						<div className="input-group paginationSearchInput listSearch">
							<div className="input-group-prepend">
								<span className="input-group-text" id="basic-addon1">
									<SearchRoundedIcon />
								</span>
							</div>
							<input
								autoComplete="off"
								className="form-control"
								type="text"
								placeholder="Search..."
								onChange={handleSearch}
							/>
						</div>
					</div>
				</div>
				<div className="scroll-y fill body scrollbox list-body">
					<div className="table-responsive overflow-initial">
						<table
							id="ember7912"
							className="table zi-table table-hover ember-view header-fixed"
						>
							{rows &&
								(rows.length > 0 ? (
									<tbody>
										{rows &&
											rows.map((row, index) => (
												<tr
													key={index}
													className={`listTr ${id === row.recordId ? "activeRecord" : ""
														}`}
													onClick={() => getBatchDetails(row.recordId)}
												>
													<td>
														<Link
															to={`/batches/${row.recordId}`}
															className={`${id === row.recordId
																? "text-primary"
																: "text-grey"
																}`}
														>
															<span className="titleTr">
																{row?.batchItemsList[0]?.itemTitle}
															</span>
															<span className="d-flex justify-content-between">
																<span className="text-primary">
																	{row.batchItemsList[0]?.batchNo}
																</span>
																<span>{row.batchItemsList[0]?.batchName}</span>
															</span>
														</Link>
													</td>
												</tr>
											))}
										{batchListDetails &&
											batchListDetails.recordsTotal > rows.length && (
												<div className="pt-3">
													<button
														className="btn mx-auto newListBtn"
														onClick={getAllBatchRecords}
													>
														Load More
													</button>
												</div>
											)}
									</tbody>
								) : (
									<div className="my-3 text-white text-center">
										No Data Available!
									</div>
								))}
						</table>
					</div>
				</div>
			</div>
			<Modal className="batchView batchViewModal" show={showModal} onHide={() => setShowModal(false)} size="xl" >
				<Modal.Body className="standardTable batchViewTable" style={{ minHeight: "150px" }}>
					{batchDetails?.batchItemsList && (
						<div className="col-5">
							<h2 className="font-size-18 font-weight-bold">
								{batchDetails?.batchItemsList[0]?.batchNo}{" "}
								{batchDetails && ` (${batchDetails?.batchItemsList[0]?.batchName})`}
							</h2>
						</div>
					)}
					{batchDetails?.batchItemsList && (
						<table className="table">
							<thead>
								<tr>
									<th>Item</th>
									<th>Quantity</th>
									<th>Production Date</th>
									<th>MFG Date</th>
									<th>Expiry Date</th>
									<th>Warehouse</th>
									<th>Physical Quality</th>
									<th>Comment</th>
									<th>Quality Parameter</th>
									<th>QC By</th>
								</tr>
							</thead>
							<tbody>
								{batchDetails.batchItemsList.map((item, index) => (
									<>
										<tr key={index}>
											<td>{item.itemTitle}</td>
											<td>
												{getFormattedNumber(item.quantity)}&nbsp;
												{item.quantityUnitTitle}
											</td>
											<td>{batchDetails.productionDate}</td>
											<td>{batchDetails.productionMfgDate}</td>
											<td>{batchDetails.productionExpDate}</td>
											<td>{batchDetails.warehouseTitle}</td>
											<td>
												<Select
													value={physicalQualityCheckEnum}
													options={physicalQualityOptions}
													onChange={(e) => {
														setPhysicalQualityCheckEnum(e);
													}}
												/>
											</td>
											<td>
												<input
													className="ember-text-field ember-view"
													type="text"
													name="qualityCheckComment"
													onChange={(e) => setQualityCheckComment(e.target.value)}
													value={qualityCheckComment}
												/>
											</td>
											<td >
												<Select
													styles={{
														control: (provided) => ({
															...provided,
															marginTop: '0px !important',
														}),
													}}
													className="ember-text-field ember-view "
													options={qualityParameterOptions}
													value={parameterizeQualityCheck}
													onChange={(e) => setParameterizeQualityCheck(e)}
													isMulti
												/>
											</td>
											<td>
												<Select
													styles={{
														control: (provided) => ({
															...provided,
															minWidth: 100,
														}),
													}}
													value={QuanlityCheckDoneBy}
													options={QcDoneBy}
													onChange={(e) => {
														setQuanlityCheckDoneBy(e);
													}}
												/>
											</td>
										</tr>
										{Array.isArray(parameterizeQualityCheck) &&
											parameterizeQualityCheck.map((option, optIndex) => (
												<div key={optIndex}>
													<input
														type="checkbox"
														id={`checkbox-${optIndex}`} behbbbb
														checked={checkedParameters[option.value] || false}
														onChange={() => handleCheckboxChange(option.value)}
													/>
													<label htmlFor={`checkbox-${optIndex}`} style={{ marginLeft: '8px' }}>
														{option.label}
													</label>
												</div>
											))
										}
									</>
								))}
							</tbody>
						</table>
					)}
				</Modal.Body>

				<Modal.Footer>

					<Button
						variant="primary"
						onClick={() => batchModalDetailsSubmit(batchDetails?.recordId)}
						disabled={batchDetails?.physicalQualityCheckEnum === "Accept" || batchDetails?.physicalQualityCheckEnum === "Reject"}
					>
						Submit
					</Button>
				</Modal.Footer>
			</Modal>
			<div className="column content-column " style={{ left: "301px" }}>
				<div className="header no-border d-flex align-items-center p-4">
					<h6 className="listTopHeading">
						{batchDetails?.batchItemsList &&
							batchDetails?.batchItemsList[0]?.batchNo}
					</h6>
					<a
						className="over-flow header-title text-uppercase"
						style={{ fontSize: "x-large" }}
					>
						&nbsp;
					</a>
					<div className="d-flex">
						{assignSyncButton() && <div className="btn-toolbar  d-flex justify-content-end align-items-center">
							<button
								id="ember499"
								className="tooltip-container ember-view btn btn-primary"
								type="button"
								name="editBtn"
								onClick={() => setShowModal(true)}
							>
								Quality check
							</button>
						</div>}
						<div className="btn-toolbar  d-flex justify-content-end align-items-center">
							<button
								id="ember499"
								className="tooltip-container ember-view btn btn-primary"
								type="button"
								name="editBtn"
								onClick={() => handleEditBatch(batchDetails.recordId)}
							>
								<EditIcon />
							</button>
						</div>
					</div>
				</div>
				<Tabs className="upperTabs">
					<TabList>
						<Tab>Primary Details</Tab>
						<Tab>Log History</Tab>
						<Tab>Batch  Details</Tab>
					</TabList>
					<TabPanel className="p-3">
						<br />
						<div className="ember-view scroll-y noscroll-x fill body scrollbox">
							<table className="customTable">
								<tbody>
									{batchDetails?.batchItemsList &&
										batchDetails?.batchItemsList.map((a, i) => {
											return (
												<Fragment key={i}>
													<tr>
														<td>Batch No.</td>
														<td className="font-large text-uppercase font-xs text-open">
															{a.batchName}
														</td>
													</tr>
													<tr>
														<td>Batch :</td>
														<td>{a.batchNo}</td>
													</tr>
													<tr>
														<td>Item:</td>
														<td>{a.itemTitle}</td>
													</tr>
													<tr>
														<td>Quantity:</td>
														<td>
															{getFormattedNumber(a.quantity)}&nbsp;
															{a.quantityUnitTitle}
														</td>
													</tr>
												</Fragment>
											);
										})}
									<tr>
										<td>Created Date and Time:</td>
										<td>{formatDateString(batchDetails.createdAt)}</td>
									</tr>
									<tr>
										<td>Production Date:</td>
										<td>{batchDetails.productionDate}</td>
									</tr>
									<tr>
										<td>MFG Date:</td>
										<td>{batchDetails.productionMfgDate}</td>
									</tr>
									<tr>
										<td>Expiry Date:</td>
										<td>{batchDetails.productionExpDate}</td>
									</tr>
									<tr>
										<td>Warehouse:</td>
										<td>{batchDetails.warehouseTitle}</td>
									</tr>
									<tr>
										<td>Approved Status:</td>
										<td>{batchDetails?.batchStatusEnum}</td>
									</tr>
									<hr></hr>
									<tr style={{ fontSize: "15px" }}>Quality Check</tr>
									<tr>
										<td>Physical Quality:</td>
										<td>{batchDetails.physicalQualityCheckEnum}</td>
									</tr>
									{batchDetails.qualityCheckComment && <tr>
										<td>Quality Comment :</td>
										<td>{batchDetails.qualityCheckComment}</td>
									</tr>}
									{batchDetails.parameterizeQualityCheck && <tr>
										<td>Parameterize Quality:</td>
										<td>

											{JSON.parse(batchDetails?.parameterizeQualityCheck)?.map((item) => (
												<div key={item.key}>
													<label>
														{item.value} -
														<span style={{ color: item.checked ? 'green' : 'red' }}>
															{item.checked ? " Pass" : " Failed"}
														</span>
													</label>
												</div>
											))}
											{/* {batchDetails.parameterizeQualityCheck} */}

										</td>
									</tr>}
								</tbody>
							</table>
						</div>
						<br />
					</TabPanel>
					<TabPanel className="p-3">
						<div className="ember-view scroll-y noscroll-x fill body scrollbox">
							<table>
								{logData.length == 0 ? (
									"No Changes Found"
								) : (
									<thead>
										<tr>
											<th>Date</th>
											<th>Changes</th>
										</tr>
									</thead>
								)}
								{logData.length >= 1 && (
									<tbody>
										{logData?.map((history, i) => (
											<tr key={i}>
												<td>
													{history?.transactionDate?.substring(0, 10)}
													:&nbsp;&nbsp;
												</td>
												<td>
													<div
														dangerouslySetInnerHTML={{
															__html: history?.message
																.replaceAll("\n", "<br />")
																.replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;"),
														}}
													/>
													{/* {history?.message.split("\n").map((b, j) => (
                                                    <div key={j}>
                                                        {b.includes("\t") ? <div style={{ marginLeft: "20px" }}>{b}</div> : b.includes("\t\t") ? <div style={{ marginLeft: "40px" }}>{b}</div> : b}
                                                    </div>
                                                ))} */}
												</td>
											</tr>
										))}
									</tbody>
								)}
							</table>
						</div>
					</TabPanel>
					<TabPanel>
						<div className="ember-view scroll-y noscroll-x fill body scrollbox py-3">
							<table
								style={{
									width: '90%',
									tableLayout: 'fixed',
									clear: 'both',
								}}
								className='pcs-label'
								id='itemTable'
								cellSpacing={0}
								cellPadding={0}
								border='1px solid black'
							>
								<thead>
									<tr>
										<td style={{ width: '10%' }}>S.No.</td>
										<td style={{ width: '100%' }}>Item</td>
									</tr>

								</thead>
								<tbody >
									{batchDetails?.batchItemsList?.map((item, index) => {
										return (
											<tr style={{ marginLeft: "8px" }} key={index}>
												<td><div style={{ width: "100%", marginLeft: "20px" }}>{index + 1}</div></td>
												<td>
													<span style={{ borderBottom: "1px solid black" }}>{item.itemTitle}</span>
													<table style={{
														width: '100%',
														tableLayout: 'fixed',
														clear: 'both',
														marginTop: "10px"
													}}
														className='pcs-label'
														id='itemTable'
														cellSpacing={0}
														cellPadding={0}
														border='1px solid black'>
														<thead>
															<tr>
																<th style={{ width: "17%" }}>Batch No</th>
																<th style={{ width: "12%" }}>Batch Qty</th>
																<th style={{ width: "10%" }}>Store</th>
																<th style={{ width: "7%" }}>Rack</th>
																<th style={{ width: "7%" }}>Cell</th>
																<th style={{ width: "7%" }}>Pallete</th>
															</tr>
														</thead>
														<tbody style={{ fontWeight: "400" }}>
															<>
																{item?.beanBatchStockTransferList?.map((e) => {
																	return <tr key={index}>
																		<td>{e?.batchNumber}</td>
																		<td>{e?.batchQuantity}</td>
																		<td>{e?.storeTitle}</td>
																		<td>{e?.rackTitle}</td>
																		<td>{e?.cellTitle}</td>
																		<td>{e?.palletTitle}</td>
																	</tr>
																})}

															</>

														</tbody>
													</table>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</TabPanel>
				</Tabs>
			</div>
			<Toaster />

		</>
	);
};

export default ViewBatch;
